export enum WeeklyOption {
  ThisWeek = 0,
  LastWeek = 1,
  NextWeek = 2,
  AllTime = 3,
  LastMonth = 4,
  ThisMonth = 5,
  NextMonth = 6,
}
